import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactApexChart from "react-apexcharts";
import moment from "moment-timezone";
import * as ActivityActions from "../../redux/actions/patient-activity-actions";

const dateFormat = "Do MMM";

class Exercise extends Component {
  constructor(props) {
    super(props);
    this.state = {exercise:[]}
  }

 async componentDidMount() {
    let patientId = this.props.match.params.id;
    let studyId = localStorage.getItem("studyId");
    let exercise = []
    if (studyId === "4") {
      exercise = await this.props.getPhysicalActivitiesNih(patientId, studyId);
    } else {
      exercise = await this.props.getPhysicalActivities(patientId);
    }
    if(exercise && exercise.data && exercise.data.length >0){
      this.setState({exercise: exercise.data})
    }

    // await this.props.getPhysicalActivities(patientId);
    // if(this.props.physicalActivity && this.props.physicalActivity.length>0){
    //   this.setState({exercise:this.props.physicalActivity})
    // }
  };

  render() {
  const {exercise} = this.state;
  
    let series = [];
    let exerciseDuration = [];
    let seriesData = {}
    if (exercise) {
        exercise.map((duration, index) => {
        var obj = {};
        obj["x"] = moment(duration.date).format(dateFormat);
        if (duration.exercise % 1 !== 0) {
          obj["y"] = parseFloat(duration.exercise).toFixed(2);
        } else {
          obj["y"] = duration.exercise;
        }
        exerciseDuration.push(obj);
      })
      series.push({ "name":"Exercise","data": exerciseDuration });
      seriesData = series;
    }
    const options = {
      chart: {
        type: 'area',
        height: 350,
        zoom: {
          enabled: true
        }
      },
      xaxis: {
        labels: {
          rotate: -90,
          // rotateAlways: false,
          // hideOverlappingLabels: true,
          showDuplicates: false,
          // trim: true,
          // minHeight: undefined,
          // maxHeight: 120,
          style: {
              colors: [],
              fontSize: '10px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 400,
              cssClass: 'apexcharts-xaxis-label',
          },
        },
      },
      dataLabels: {
        enabled: false
      }
    };

    return (
      <div id = "chart"  >
      {seriesData ?  <ReactApexChart options={options} series={seriesData} type="area" height={350} width={"100%"}/>:""}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    physicalActivity: state.activity.getPhysicalActivity,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({...ActivityActions}, dispatch);
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Exercise)
);
